import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as cls from "./miniModalNotifications.module.scss";
import {
  currentNotificationAction,
  showNotificationDetailAction,
} from "../../src/redux/actions/actions";
// import ModalNotifications from "../../src/components/modalnotifications/ModalNotifications";
import UnreadIcon from "../../src/resources/icons/UnreadIcon";
/**
 * Компонент мини-модального окна уведомлений.
 * @module MiniModalNotifications
 * @author Айдарбек Артур уулу <kulubaev97@gmail.com>
 */
export default function MiniModalNotifications({
  openMiniModal,
  setOpenMiniModal,
}) {
  // const [key, setKey] = useState(0);
  // const { open } = useSelector((state) => state.notifications);
  // const { isDead_lock } = useSelector((state) => state.deadLock);

  const handleClose = () => {
    setOpenMiniModal(false);
  };

  const { notificationsSummaries } = useSelector(
    (state) => state.notifications
  );

  const dispatch = useDispatch();

  const handleModalOpen = (data) => {
    dispatch(currentNotificationAction(data));
    dispatch(showNotificationDetailAction(true));
    // setKey((prevKey) => prevKey + 1);
  };

  if (notificationsSummaries) {
    return (
      <div
        className={cls.dialog}
        style={{ display: openMiniModal ? "block" : "none" }}
      >
        <div
          className={cls.overlay}
          onClick={handleClose}
          style={{ display: openMiniModal ? "block" : "none" }}
        />
        <div className={cls.dialog_paper}>
          <div className={cls.dialogTitle}>Оповещения</div>
          <div className={cls.dialogContent}>
            {notificationsSummaries?.rows.map(
              ({ header, is_event_actual, planning_event_id }) => (
                <div
                  key={planning_event_id}
                  onClick={() =>
                    handleModalOpen({ is_event_actual, planning_event_id })
                  }
                  className={cls.listItemButton}
                >
                  <div className={cls.iconContainer}>
                    {!is_event_actual && <UnreadIcon />}
                  </div>
                  <span className={cls.listItemText}>{header}</span>
                </div>
              )
            )}
          </div>
        </div>
        {/* {open && !isDead_lock && <ModalNotifications key={key} />} */}
      </div>
    );
  }
  return null;
}
